import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import SearchInput from "components/SearchInput";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import MobileView from "components/Mobile/MobileView";
import DesktopView from "components/Mobile/DesktopView";

import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";
import TemplateFeatureGateTooltip from "./FeatureGate/Tooltip";
import { TemplateActions } from "./FeatureGate/types";
import TemplatesUpSell from "./UpSell";

type TemplatesWorkbenchPageLayoutProps = {
  children?: ReactNode;
  onCreate?: () => void;
  showUpSell?: boolean;
  hideActions?: boolean;
  titleId: string;
};

const TemplatesWorkbenchPageLayout = ({
  children,
  onCreate,
  showUpSell,
  hideActions,
  titleId,
}: TemplatesWorkbenchPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Templates Workbench · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle id={titleId}>Templates Workbench</ViewHeaderTitle>
          <MobileView>
            {!hideActions && onCreate && (
              <TemplateFeatureGateTooltip
                action={TemplateActions.CreateTemplate}
                on={({ isDisabled, ...props }) => (
                  <Button {...props} onPress={onCreate} variant="primary" disabled={isDisabled}>
                    Create template
                  </Button>
                )}
              />
            )}
          </MobileView>
        </ViewHeaderWrapper>

        {!hideActions && !showUpSell && (
          <ViewHeaderWrapper direction="row">
            <SearchInput
              placeholder="Search templates..."
              filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
            />
            <FiltersMobileTriggerButton />
            <DesktopView>
              <DocumentationIconButton
                href={getDocsUrl("/concepts/template")}
                tooltipText="Go to template documentation"
              />
              {onCreate && (
                <TemplateFeatureGateTooltip
                  action={TemplateActions.CreateTemplate}
                  on={({ isDisabled, ...props }) => (
                    <Button {...props} onPress={onCreate} variant="primary" disabled={isDisabled}>
                      Create template
                    </Button>
                  )}
                />
              )}
            </DesktopView>
          </ViewHeaderWrapper>
        )}
      </ViewHeader>

      {showUpSell ? <TemplatesUpSell /> : children}
    </>
  );
};

export default TemplatesWorkbenchPageLayout;
